import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styles from '../Toolbar.styles';
import {setSelectedToken, toggleDestructionTool} from '../../../redux/actions';
import {
  selectDestructionToolActive,
  selectSelectedToken,
  selectIsMissionEditorMode,
} from '../../../redux/reducers/privateStateReducer/selectors';
import {selectPlayers} from '../../../redux/reducers/sharedStateReducer/selectors';
import {CENTRAL_QUARTER_PREFIX} from '../../../constants/tokens';
import {buildMissionUnitToken} from '../../../configs/campaigns/missionFormat';
import UNIT_TYPES from '../../../configs/units';
import UnitIcon from '../NewUnitToolbar/UnitIcon/UnitIcon';
import {getUnitIconClassNameForButton} from '../../../utils/unit/getUnitIconClassNameForButton';
import {getPlayerHexColor} from '../../../utils/players/getPlayerHexColor';
import './MissionEditorToolbars.css';

const UNIT_TYPE_LIST = Object.values(UNIT_TYPES);

/**
 * Дополнительные инструменты расстановки, доступные ТОЛЬКО в редакторе
 * миссий: центральные кварталы игроков и отряды любого игрока (в обычном
 * редакторе поля можно ставить лишь нейтральный центральный квартал и
 * нейтральные отряды).
 *
 * Игрок для обоих инструментов выбирается одной палитрой сверху — по цветам
 * из состава партии, который автор задал на предыдущем шаге.
 */
const MissionEditorToolbars = () => {
  const dispatch = useDispatch();
  const isEditorMode = useSelector(selectIsMissionEditorMode);
  const players = useSelector(selectPlayers);
  const selectedToken = useSelector(selectSelectedToken);
  const destructionToolActive = useSelector(selectDestructionToolActive);

  const [selectedColor, setSelectedColor] = useState(null);

  if (!isEditorMode || players.length === 0) {
    return null;
  }

  const color = selectedColor || players[0].color;

  const selectToken = (tokenId) => {
    if (destructionToolActive) {
      dispatch(toggleDestructionTool());
    }
    dispatch(setSelectedToken(tokenId));
  };

  const centralQuarterToken = CENTRAL_QUARTER_PREFIX + color;

  return (
    <div style={styles.container}>
      <div className={'mission-editor-toolbars'}>
        <div className={'mission-editor-toolbars_players'}>
          {players.map((player) => (
            <button
              key={player.color}
              type={'button'}
              className={`mission-editor-toolbars_player ${color === player.color ? 'mission-editor-toolbars_player--active' : ''}`}
              style={{backgroundColor: getPlayerHexColor(player.color)}}
              title={player.name}
              onClick={() => setSelectedColor(player.color)}
            />
          ))}
        </div>

        <div className={'mission-editor-toolbars_tools'}>
          <button
            type={'button'}
            className={`toolbar-button ${selectedToken === centralQuarterToken ? 'toolbar-button-selected' : ''}`}
            title={'Центральный квартал игрока'}
            onClick={() => selectToken(centralQuarterToken)}
          >
            <img
              className={'mission-editor-toolbars_quarter-icon'}
              src={'/img/hexes/quarter_base.4ec61fc0.png'}
              alt={'Центральный квартал'}
            />
          </button>

          {UNIT_TYPE_LIST.map((unitType) => {
            const tokenId = buildMissionUnitToken(color, unitType.id);
            return (
              <button
                key={unitType.id}
                type={'button'}
                className={`toolbar-button ${selectedToken === tokenId ? 'toolbar-button-selected' : ''}`}
                title={`${unitType.label} игрока`}
                onClick={() => selectToken(tokenId)}
              >
                <UnitIcon
                  unitType={unitType.id}
                  playerColor={color}
                  className={getUnitIconClassNameForButton(unitType.id)}
                />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MissionEditorToolbars;
